module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible) ? _c('div', {
    staticClass: "modal",
    class: {
      'modal__is-relative': _vm.relativeToParent
    }
  }, [(_vm.hasBg) ? _c('div', {
    staticClass: "modal__bg"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "container",
    staticClass: "modal__container",
    style: (_vm.modalWidth)
  }, [_c('div', {
    staticClass: "modal__header-actions"
  }, [_vm._t("header-buttons"), _vm._v(" "), (_vm.closeButton) ? _c('div', {
    staticClass: "modal__close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.cancel,
      "width": 12,
      "height": 12
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal__body"
  }, [_c('div', {
    staticClass: "modal__title"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), (!_vm.loading) ? [_c('div', {
    ref: "content",
    staticClass: "modal__content",
    class: {
      'modal__content--no-padding': _vm.removePadding
    },
    style: (_vm.contentHeightStyle)
  }, [_vm._t("default")], 2), _vm._v(" "), (!_vm.hideActions) ? _c('div', {
    staticClass: "modal__actions"
  }, [_vm._t("actions")], 2) : _vm._e()] : _c('div', {
    staticClass: "modal__loading-container"
  }, [_c('loading-dots')], 1)], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ef84706"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/modal/Modal.vue
// module id = 1984
// module chunks = 0